import * as React from 'react';
import { FC } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import { blue } from 'src/constants/stylesheet';
import { useApi } from 'src/@context/Api';

const animation = {
    '0%': {
        WebkitTransform: 'scale(0)',
        transform: 'scale(0)',
    },
    '40%': {
        WebkitTransform: 'scale(1.0)',
        transform: 'scale(1.0)',
    },
    '80%': {
        WebkitTransform: 'scale(0)',
        transform: 'scale(0)',
    },
    '100%': {
        WebkitTransform: 'scale(0)',
        transform: 'scale(0)',
    },
};

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            padding: '2rem 0',
            textAlign: 'center',
        },
        bounce1: {},
        bounce2: {},
        bounce3: {},

        spinner: {
            margin: '70px auto 50px',
            width: 150,
            textAlign: 'center',

            '& > div': {
                width: 8,
                height: 8,
                backgroundColor: blue,
                marginRight: 5,

                borderRadius: '100%',
                display: 'inline-block',
                animation: '$animation 1.4s infinite ease-in-out both',
            },

            '& $bounce1': {
                WebkitAnimationDelay: '-0.32s',
                animationDelay: '-0.32s',
            },

            '& $bounce2': {
                WebkitAnimationDelay: '-0.16s',
                animationDelay: '-0.16s',
            },
        },
        text: {
            color: blue,
            fontSize: '1.3rem',
            display: 'inline-block',
            marginRight: 5
        },
        '@keyframes animation': animation
    }));

const Loading: FC = () => {
    const cls = useStyles();
    
    const { app } = useApi();
    const config = app && app.Config;
    const translationsItems = config && config.TranslationItems;
    const loading = translationsItems && translationsItems.find(t => t.UID === 'loading');

    return (
        <div className={cls.spinner}>
            <span className={cls.text}>{loading && loading.Translation || ''}</span>
            <div className={cls.bounce1} />
            <div className={cls.bounce2} />
            <div className={cls.bounce3} />
        </div>
    );
}

export default Loading;


// WEBPACK FOOTER //
// ./src/Components/Loading.tsx